export const GET_COLLECTION = 'GET_COLLECTION';
export const GET_COLLECTION_SUCCESS = 'GET_COLLECTION_SUCCESS';

export const FETCH_COLLECTION_FEED = 'FETCH_COLLECTION_FEED';
export const FETCH_COLLECTION_FEED_SUCCESS = 'FETCH_COLLECTION_FEED_SUCCESS';

export const FETCH_COLLECTION_ARCHIVE = 'FETCH_COLLECTION_ARCHIVE';
export const FETCH_COLLECTION_ARCHIVE_SUCCESS = 'FETCH_COLLECTION_ARCHIVE_SUCCESS';

export const SET_COLLECTION = 'SET_COLLECTION';
export const DELETE_COLLECTION = 'DELETE_COLLECTION';

export const CLOSE_LOADING = 'CLOSE_LOADING';
export const TOUCH_DOWNLOAD_MODAL = 'TOUCH_DOWNLOAD_MODAL'

export const touchDownloadModal = () =>({
  type: TOUCH_DOWNLOAD_MODAL,
})

export const getCollection = (data) => ({
  type: GET_COLLECTION,
  data
})

export const getCollectionSuccess = (data) => ({
  type: GET_COLLECTION_SUCCESS,
  data,
})

export const fetchCollectionFeed = (action) => ({
  type: FETCH_COLLECTION_FEED,
  action
})

export const fetchCollectionFeedSuccess = (data) => ({
  type: FETCH_COLLECTION_FEED_SUCCESS,
  data,
})

export const fetchCollectionAchive = (data) => ({
  type: FETCH_COLLECTION_ARCHIVE,
  data
})

export const fetchCollectionAchiveSuccess = (data) => ({
  type: FETCH_COLLECTION_ARCHIVE_SUCCESS,
  data,
})

export const setCollection = (data) => ({
  type: SET_COLLECTION,
  data,
})

export const deleteCollection = (data) => ({
  type: DELETE_COLLECTION,
  data
})

export const closeLoading = (data) => ({
  type: CLOSE_LOADING,
  data
})



/** WEBPACK FOOTER **
 ** ./src/app/modules/collection/actions.js
 **/